import { Link, useNavigate } from "react-router-dom";
import { max, min, showMoneyShort } from "../Data/Money";
import { PersonWalking } from "react-bootstrap-icons";
import { Button } from "./Button";
import { useAtom } from "jotai";
import { monthlyCheckoutAtom } from "../Data/Atoms";
import { LocalDate } from "@js-joda/core";
import { Facility } from "../Data/ApiTypes";
import { facilityImg } from "../Data/Common";

export interface ResultMonthlyEntryProps {
    facility:   Facility;
    onClick:    () => void;
    className?: string;
    start:      LocalDate;
    walkingTime?: string;
}

export function ResultMonthlyEntry( props: ResultMonthlyEntryProps ) {
    //hooks
    const nav = useNavigate();
    const [monthlyCheckout, setMonthlyCheckout] = useAtom( monthlyCheckoutAtom );

    //local vars
    const { facility, start, className = "", walkingTime } = { ...props };
    const { name, listedPlans, listImageId } = { ...props.facility };

    function detailsClick( e: React.MouseEvent<HTMLButtonElement, MouseEvent> ) {
        e.stopPropagation();
        props.onClick();
    }

    function bookNowClick( e: React.MouseEvent<HTMLButtonElement, MouseEvent> ) {
        setMonthlyCheckout( {
            isInvite: false,
            facility: facility,
            start: start,
            option: listedPlans[0],
            quantity: 1,
            vehicles: [],
            couponPriceId: null
        } );
        e.stopPropagation();
        nav( "/checkout/monthly" );
    }

    const prices = listedPlans.map( plan => plan.price );
    const [minPrice, maxPrice] = [min( prices ), max( prices )];
    return <div className={`facility-result rounded-4 p-4 mb-3 shadow border border-2 ${className}`}
                onClick={ () => props.onClick() }>
        <div>
        <img className="facility-result-pic"
             src={facilityImg( listImageId )}
             style={{ aspectRatio: "1 / 1", objectFit: "cover" }} />
        </div>
        <div className="facility-result-info">
            <div className="grid-col-1">
                <div className="fw-bold">
                    {name}
                </div>
                {walkingTime && (
                    <div className="d-flex align-items-center small text-muted">
                        <PersonWalking />&thinsp;{walkingTime}
                    </div>
                )}
            </div>
            <div className="grid-col-2 text-end">
                <div className="fs-5 fw-bold">
                    {showMoneyShort( minPrice )}{listedPlans.length > 1 ? "+" : ""}<span className="text-muted fw-normal" style={{ fontSize: "0.6em" }}>/mo</span>
                </div>
                {listedPlans.length > 1 && (
                    <div style={{ fontSize: "0.75em" }} className="text-muted">
                        {listedPlans.length} options
                    </div>
                )}
            </div>
        </div>
        <div className="facility-result-bottom">
            <Button className="w-100" onClick={ detailsClick }>Details</Button>
            <Button className="w-100 btn-main" onClick={ bookNowClick }>
                Book
            </Button>
        </div>
    </div>;
}